import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];
import { useInitialOrDefaultFieldValue } from '../../hooks/useInitialOrDefaultFieldValue';
import { Textarea as CheggUiTextArea } from '@chegg-ui/textarea';
import React from 'react';
import { FastField } from 'formik';
export var Textarea = function Textarea(_ref) {
  var name = _ref.name,
    rest = _objectWithoutProperties(_ref, _excluded);
  useInitialOrDefaultFieldValue(name, '');
  return /*#__PURE__*/React.createElement(FastField, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/React.createElement(CheggUiTextArea, _extends({}, rest, {
      value: field.value,
      onChange: function onChange(value) {
        return form.setFieldValue(name, value);
      }
    }));
  });
};